import React from "react";

import { useTranslation } from "utils";

import { CROP_TYPE } from "models";

import { Flex, Icon } from "components";

import { useCropExplorationContext } from "pages/app/crop-explorer/CropExplorationContext.tsx";
import { CropCard, CropCardHeader, CropCardProps } from "pages/app/crop-explorer/components/CropCard.tsx";

export type CropCardWrapperProps = {
  hasCrop: boolean;
  cropType: CROP_TYPE;
  isActive: boolean;
  dataTestId?: string;
  cropCardProps?: Omit<CropCardProps, "cropType" | "dataTestId"> | null;
  isTourStep?: boolean;
};

const AddCropCard = ({
  cropType,
  t,
  dataTestId,
  mRef,
}: {
  cropType: CROP_TYPE;
  t: (key: string) => string;
  dataTestId?: string;
  mRef?: React.RefObject<HTMLDivElement>;
}) => (
  <Flex ref={mRef} data-testid={`crop-card-add-${dataTestId}`} className="crop-card add layout" align="center" gap="0.5rem">
    <Icon dataTestId={`crop-card-add-${dataTestId}-add-icon`} className="add-icon" iconName="klim/plus" />
    <span data-testid={`crop-card-add-${dataTestId}-add-text`} className="add-text">
      {t(`timeline.addCropCard.${cropType.toLowerCase()}`)}
    </span>
  </Flex>
);

const EmptyCardActive = ({ cropType, t, dataTestId }: { cropType: CROP_TYPE; t: (key: string) => string; dataTestId?: string }) => (
  <Flex data-testid={`crop-card-empty-active-${dataTestId}`} className="crop-card active layout" vertical={true}>
    <CropCardHeader
      dataTestId={`crop-card-empty-active-${dataTestId}-header`}
      label={t(`cropCard.${cropType.toLowerCase()}`)}
      name={`[${t("addEditCrop.noName")}]`}
    />
  </Flex>
);

export const CropCardWrapper = ({ hasCrop, cropType, isActive, dataTestId, cropCardProps, isTourStep }: CropCardWrapperProps) => {
  const { t } = useTranslation("cropExplorer");
  const { tourRefStep4AddEditCrop } = useCropExplorationContext();

  if (!hasCrop && isActive) return <EmptyCardActive dataTestId={dataTestId} cropType={cropType} t={t} />;
  if (!hasCrop) return <AddCropCard dataTestId={dataTestId} cropType={cropType} t={t} mRef={isTourStep ? tourRefStep4AddEditCrop : undefined} />;
  if (!cropCardProps) return <></>;
  return (
    <CropCard
      cropId={cropCardProps.cropId}
      cropType={cropType}
      cropName={cropCardProps.cropName}
      dataTestId={dataTestId}
      isActive={cropCardProps.isActive}
      hasResidue={cropCardProps.hasResidue}
      mRef={isTourStep ? tourRefStep4AddEditCrop : undefined}
    />
  );
};
